<!-- <section class="text-center breadcrumbs" *ngIf="hasActiveBreadcrumbs">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <app-breadcrumbs [breadcrumbsService]="breadcrumbsService"></app-breadcrumbs>
      </div>
    </div>
  </div>
</section> -->
<app-header-title *ngIf="isAllowedShowHeader"></app-header-title>
<router-outlet></router-outlet>
